export default __webpack_public_path__ + "/dist/images/password-inactive.svg";